



































import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import firebase from '@/plugins/firebase'
import { Company } from '@/models/company'
import { logAdd } from '@/models/log'

@Component
export default class CompanyUpdateName extends Vue {
  @Prop({ type: Object, required: true }) doc!: firebase.firestore.QueryDocumentSnapshot<Company>
  @Ref('form') form!: { validate(): boolean }

  menu = false
  name = this.item.name
  rules = [
    (v: string): boolean | string => !!v || '이름을 입력해야합니다'
  ]

  get item (): Company {
    return this.doc.data()
  }

  save (): void {
    if (!this.form.validate()) return
    this.doc.ref.set({ name: this.name }, { merge: true })
    this.menu = false
    logAdd('update', '회사 이름 변경', `${this.item.name} => ${this.name}`, 'admin')
    // this.$toast.success('good')
  }
}
